<template>
  <div v-show="innerShouldShow">
    <div v-if="!innerIsReview">
      <validation-provider
              v-slot="{ errors }"
              :name="label || 'This'"
              :rules="rules"
              v-bind="providerProps"
              v-show="innerShouldShow"
              :vid="'validate-' + fieldAssignmentId"
              :ref="'validate' + fieldAssignmentId"
      >
        <v-menu
          v-model="showMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template #activator="{ on, attrs }">
            <v-text-field
              v-model="dateModel"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="{ ...extraProps.input, ...inputDefaults, ...attrs }"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="dateModel"
            v-bind="vProps"
            @input="showMenu = false"
          ></v-date-picker>
        </v-menu>
      </validation-provider>
    </div>
    <div v-else>
      <type-review
              v-if="extraProps"
              :label="label"
              :directions="directions"
              :should-show="innerShouldShow"
              :show-edit-button="extraProps.editButton"
              :page-number="extraProps.originalPageNumber"
              @goToPage="goToPage($event)"
      >
        <div v-if="innerValue">
          <span v-html="innerValue"></span>
        </div>
        <div v-else>N/A</div>
      </type-review>
    </div>
  </div>
</template>

<script>
import formMixin from '../formMixin';
import TypeReview from './TypeReview';
export default {
  name: 'TypeDate',
  mixins: [formMixin],
  components:{
    TypeReview
  },
  data() {
    return {
      showMenu: false,
    }
  },
  mounted() {
    this.fieldLoaded(); // signal to the form we are loaded
  },
  computed: {
    defaults() {
      return {}
    },
    inputDefaults() {
      return {
        label: this.innerLabel,
        directions: this.directions,
        persistentHint: true
      };
    },
    dateModel: {
      get() {
        return this.value
          ? this.$dateTime.dateToLocal(this.value, 'YYYY-MM-DD')
          : ''
      },
      set(v) {
        this.$emit('input', this.$dateTime.dateToUtc(v))
      },
    },
    rules() {
      return (this.enableValidation) ? {
        ...this.validation_settings,
        ...{
          required:
                  !!this.validation_settings.required &&
                  !!this.innerShouldShow
        }
      } : {};
    },
  },
}
</script>
